"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configure = configure;
Object.defineProperty(exports, "useGridDebug", {
  enumerable: true,
  get: function get() {
    return _hooks.useGridDebug;
  }
});
Object.defineProperty(exports, "BlogLayout", {
  enumerable: true,
  get: function get() {
    return _blogLayout["default"];
  }
});
Object.defineProperty(exports, "DocsLayout", {
  enumerable: true,
  get: function get() {
    return _docsLayout["default"];
  }
});
Object.defineProperty(exports, "PageLayout", {
  enumerable: true,
  get: function get() {
    return _pageLayout["default"];
  }
});
Object.defineProperty(exports, "SiteLayout", {
  enumerable: true,
  get: function get() {
    return _siteLayout["default"];
  }
});
Object.defineProperty(exports, "Ph", {
  enumerable: true,
  get: function get() {
    return _helpers.Ph;
  }
});
Object.defineProperty(exports, "Dump", {
  enumerable: true,
  get: function get() {
    return _helpers.Dump;
  }
});
exports.Link = exports.Head = void 0;

var _hooks = require("./hooks");

var _blogLayout = _interopRequireDefault(require("./layouts/blog-layout"));

var _docsLayout = _interopRequireDefault(require("./layouts/docs-layout"));

var _pageLayout = _interopRequireDefault(require("./layouts/page-layout"));

var _siteLayout = _interopRequireDefault(require("./layouts/site-layout"));

var _helpers = require("./helpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // hooks
// layouts

/* NEW API */


var Head = function Head(props) {
  return null;
}; // eslint-disable-next-line jsx-a11y/anchor-has-content


exports.Head = Head;

var Link = function Link(props) {
  return /*#__PURE__*/React.createElement("a", props);
};

exports.Link = Link;

function configure(_ref) {
  var frameworkName = _ref.frameworkName,
      headComponent = _ref.headComponent,
      linkComponent = _ref.linkComponent,
      _ref$mdxComponents = _ref.mdxComponents,
      mdxComponents = _ref$mdxComponents === void 0 ? {
    a: Link
  } : _ref$mdxComponents,
      remarkPlugins = _ref.remarkPlugins,
      rehypePlugins = _ref.rehypePlugins,
      _ref$basePath = _ref.basePath,
      basePath = _ref$basePath === void 0 ? '/' : _ref$basePath;
  /* set Head and Link components */

  exports.Head = Head = headComponent;
  exports.Link = Link = linkComponent;
  Object.assign(Head, frameworkName);
  Object.assign(Link, frameworkName);
}